import React from 'react';
import { StackScreen } from '@banhala/ui-kit';
import { WebView } from 'shared/src/component/WebWebView';
import { useWebBaseURL } from 'shared/src/hooks';
import { isNotNil } from 'shared/src/utils';
import { CartIcon } from 'shared/src/component';
import { AnalyticsScreen } from 'shared/src/context';
import {
  NotificationIcon,
  SettingIcon,
} from 'shared/src/component/HeaderIcons';

const SCREEN_NAME = 'MY_PAGE';
export const MyPageScreen = () => {
  const webBaseUrl = useWebBaseURL();

  return (
    <AnalyticsScreen screen={SCREEN_NAME}>
      <StackScreen
        title={'마이페이지'}
        hideBackButton={true}
        rightIcons={[
          <SettingIcon screen={SCREEN_NAME} />,
          <NotificationIcon screen={SCREEN_NAME} />,
          <CartIcon />,
        ]}
      >
        {isNotNil(webBaseUrl) && (
          <WebView
            source={{ uri: `${webBaseUrl}/mypage/me?global_layout=app` }}
          />
        )}
      </StackScreen>
    </AnalyticsScreen>
  );
};
